import { jsx as _jsx } from "react/jsx-runtime";
import { IFrameWarning } from '../../iframe-page';
export var NotificationsIFrameHeader = function () { return (_jsx(IFrameWarning, { children: "All changes must be saved within this window." })); };
